import { render, staticRenderFns } from "./CardTemperature.vue?vue&type=template&id=38c2408f&scoped=true&"
import script from "./CardTemperature.vue?vue&type=script&lang=js&"
export * from "./CardTemperature.vue?vue&type=script&lang=js&"
import style0 from "./CardTemperature.vue?vue&type=style&index=0&id=38c2408f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2408f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemTitle,VSpacer})
